import React from 'react';

const ProjectCard = ({ title, img, altText, desc, demo, docs, timeline }) => {
  return (
    <div className="project-card">
      <div className="project-card-head">
        <img
          className="project-img"
          src={`/assets/projects/${img}`}
          alt={altText}
          loading="lazy"
        />
      </div>
      <div className="project-card-body">
        <div className="project-header">
          <span className="project-heading">{title}</span>
        </div>
        <span>{desc}</span>
        <div className="button-container">
          <span>
            <a
              title="Demo"
              className="links buttons"
              href={demo}
              target="_blank"
              rel="noopener noreferrer"
            >
              Demo
            </a>
            &nbsp;|
          </span>
          <span>
            <a
              title="GitHub"
              className="links buttons"
              href={docs}
              target="_blank"
              rel="noopener noreferrer"
            >
              Docs
            </a>
          </span>
          <span className="project-timeline">{timeline}</span>
        </div>
      </div>
    </div>
  );
};

export default ProjectCard;
